import { render, staticRenderFns } from "./HomeworkPlaningMobile.vue?vue&type=template&id=223aaf4e"
import script from "./HomeworkPlaningMobile.vue?vue&type=script&lang=js"
export * from "./HomeworkPlaningMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports